import React from 'react';
import PropTypes from 'prop-types';
import Script from 'react-load-script';
import Map from './Map';

class ScriptLoadingMap extends React.Component {
  static propTypes = {
    googleMapsApiKey: PropTypes.string,
  };
  static defaultProps = {
    googleMapsApiKey: 'AIzaSyBPak0kWjgy0cLE5vtaHXdbzECMkGu54S0',
  };

  state = {
    scriptLoaded: false,
  };

  handleScriptLoad = () => {
    this.setState({ scriptLoaded: true });
  };

  render() {
    return (
      <div>
        <Script
          url={`https://maps.googleapis.com/maps/api/js?key=${this.props.googleMapsApiKey}`}
          onLoad={this.handleScriptLoad}
        />
        {this.state.scriptLoaded && <Map {...this.props} />}
      </div>
    );
  }
}

export default ScriptLoadingMap;



// WEBPACK FOOTER //
// ./src/shared/components/Map/ScriptLoadingMap.js